import { createMigration } from './utils';

export const migrationTo9_165 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            const audioId = map.get('audioId');

            if (audioId) {
                const audioStartTime = map.get('audioStartTime', 0);
                map.setIn(['audioAssets', audioId, 'startTime'], audioStartTime);
                map.setIn(['audioAssets', audioId, 'endTime'], null);
            }

            map.delete('audioStartTime');
        });
    },
});
